import React from 'react';
import { makeStyles } from '@material-ui/core';

import { DownloadIcon } from 'assets/svg';
import PrimaryButton from 'components/Buttons/PrimaryButton';

const useStyles = makeStyles(theme => ({
	button: {
		padding: '14px 18px',
		marginRight: theme.spacing(1),
		background: theme.palette.primary
	},
	downloadIcon: {
		'& path': {
			stroke: theme.palette.white
		}
	}
}));

const ExportButton = React.forwardRef((props, ref) => {
	const classes = useStyles();

	return (
		<PrimaryButton
			ref={ref}
			startIcon={<DownloadIcon width={16} height={16} className={classes.downloadIcon} />}
			className={classes.button}
			{...props}
		>
			{props.children}
		</PrimaryButton>
	);
});

ExportButton.displayName = 'ExportButton';

export default ExportButton;
